var React = require('react');

function Rocket (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.566 1.194c.434 2.013.434 3.588.428 5.163 0 6.418-3.463 10.299-8 13.193v6.528c0 1.022-.742 2.222-1.656 2.679l-6.169 3.087a1.776 1.776 0 0 1-.669.157 1.5 1.5 0 0 1-1.5-1.5v-6.49l-1.404 1.404c-.323.323-.957.586-1.414.586s-1.091-.262-1.414-.586l-3.181-3.182c-.323-.323-.586-.957-.586-1.414s.262-1.091.586-1.414l1.404-1.404H1.505a1.5 1.5 0 0 1-1.5-1.5c0-.195.071-.495.158-.669l3.089-6.175c.458-.913 1.658-1.655 2.679-1.656h6.513c2.887-4.55 6.756-8 13.206-8 1.569 0 3.143 0 5.156.431.346.074.688.416.762.762zM24 10.5a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 0 0 5z"}));
}

Rocket.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Rocket;

Rocket.default = Rocket;
